export default __webpack_public_path__ + "static/media/7.93195462.jpeg";